import { useEffect, useState } from "react";
import { Accordion } from "../../../components/accordion/accordion.jsx";
import { Header } from "../../../components/header/header.jsx";
import { useSelector } from "react-redux";
import { PageLoader } from "../../../components/loader/pageLoader.jsx";
import UserAPI from "../../../api/UserAPI.js";

export const FAQPage = () => {
    const [data, setData] = useState([]);
    const cafeId = useSelector(state => state.user.userData.cafeId);

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!cafeId) return;

        UserAPI
            .fetchFAQ(cafeId)
            .then(setData)
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [cafeId]);

    if (loading) {
        return <PageLoader />;
    }

    return (
        <>
            <Header title="FAQ" />
            <Accordion data={data} />
        </>
    )
}